import React from 'react';

const TwitterShareButton = ({ url, text, hashtags, via }) => {
  const handleClick = () => {
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}&hashtags=${encodeURIComponent(hashtags)}&via=${encodeURIComponent(via)}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <button onClick={handleClick}>
      <img src={process.env.NEXT_PUBLIC_WEPRODIGI + '/uploads/images/blog/x.svg'} width={26} height={26}
           alt="share x " />
    </button>
  );
};

export default TwitterShareButton;
